import { render } from "./BuildingTypeDetail.vue?vue&type=template&id=5bb1a7de"
import script from "./BuildingTypeDetail.vue?vue&type=script&lang=js"
export * from "./BuildingTypeDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__